import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/taxingUnitGroups';

const namespace = 'ASSESSMENT';

export const TAXING_UNIT_GROUPS_FETCH_ALL_START = `${namespace}/TAXING_UNIT_GROUPS_FETCH_ALL_START`;
export const TAXING_UNIT_GROUPS_FETCH_ALL_SUCCESS = `${namespace}/TAXING_UNIT_GROUPS_FETCH_ALL_SUCCESS`;
export const TAXING_UNIT_GROUPS_FETCH_ALL_ERROR = `${namespace}/TAXING_UNIT_GROUPS_FETCH_ALL_ERROR`;

export const TAXING_UNIT_GROUPS_FETCH_START = `${namespace}/TAXING_UNIT_GROUPS_FETCH_START`;
export const TAXING_UNIT_GROUPS_FETCH_SUCCESS = `${namespace}/TAXING_UNIT_GROUPS_FETCH_SUCCESS`;
export const TAXING_UNIT_GROUPS_FETCH_ERROR = `${namespace}/TAXING_UNIT_GROUPS_FETCH_ERROR`;

export const TAXING_UNIT_GROUPS_INSERT_START = `${namespace}/TAXING_UNIT_GROUPS_INSERT_START`;
export const TAXING_UNIT_GROUPS_INSERT_SUCCESS = `${namespace}/TAXING_UNIT_GROUPS_INSERT_SUCCESS`;
export const TAXING_UNIT_GROUPS_INSERT_ERROR = `${namespace}/TAXING_UNIT_GROUPS_INSERT_ERROR`;

export const TAXING_UNIT_GROUPS_UPDATE_START = `${namespace}/TAXING_UNIT_GROUPS_UPDATE_START`;
export const TAXING_UNIT_GROUPS_UPDATE_SUCCESS = `${namespace}/TAXING_UNIT_GROUPS_UPDATE_SUCCESS`;
export const TAXING_UNIT_GROUPS_UPDATE_ERROR = `${namespace}/TAXING_UNIT_GROUPS_UPDATE_ERROR`;

export const TAXING_UNIT_GROUPS_DELETE_START = `${namespace}/TAXING_UNIT_GROUPS_DELETE_START`;
export const TAXING_UNIT_GROUPS_DELETE_SUCCESS = `${namespace}/TAXING_UNIT_GROUPS_DELETE_SUCCESS`;
export const TAXING_UNIT_GROUPS_DELETE_ERROR = `${namespace}/TAXING_UNIT_GROUPS_DELETE_ERROR`;

export const TAXING_UNIT_LIST_FETCH_START = `${namespace}/TAXING_UNIT_LIST_FETCH_START`;
export const TAXING_UNIT_LIST_FETCH_SUCCESS = `${namespace}/TAXING_UNIT_LIST_FETCH_SUCCESS`;
export const TAXING_UNIT_LIST_FETCH_ERROR = `${namespace}/TAXING_UNIT_LIST_FETCH_ERROR`;

export const TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_START = `${namespace}/TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_START`;
export const TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_SUCCESS = `${namespace}/TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_SUCCESS`;
export const TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_ERROR = `${namespace}/TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_ERROR`;

export const TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_START = `${namespace}/TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_START`;
export const TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_SUCCESS = `${namespace}/TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_SUCCESS`;
export const TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_ERROR = `${namespace}/TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_ERROR`;

export const TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_START = `${namespace}/TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_START`;
export const TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_SUCCESS = `${namespace}/TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_SUCCESS`;
export const TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_ERROR = `${namespace}/TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_ERROR`;

export const EXEMPTION_MAPPINGS_FETCH_START = `${namespace}/EXEMPTION_MAPPINGS_FETCH_START`;
export const EXEMPTION_MAPPINGS_FETCH_SUCCESS = `${namespace}/EXEMPTION_MAPPINGS_FETCH_SUCCESS`;
export const EXEMPTION_MAPPINGS_FETCH_ERROR = `${namespace}/EXEMPTION_MAPPINGS_FETCH_ERROR`;

export const EXEMPTION_APPLYTO_FETCH_START = `${namespace}/EXEMPTION_APPLYTO_FETCH_START`;
export const EXEMPTION_APPLYTO_FETCH_SUCCESS = `${namespace}/EXEMPTION_APPLYTO_FETCH_SUCCESS`;
export const EXEMPTION_APPLYTO_FETCH_ERROR = `${namespace}/EXEMPTION_APPLYTO_FETCH_ERROR`;

export const EXEMPTION_TYPES_FETCH_START = `${namespace}/EXEMPTION_TYPES_FETCH_START`;
export const EXEMPTION_TYPES_FETCH_SUCCESS = `${namespace}/EXEMPTION_TYPES_FETCH_SUCCESS`;
export const EXEMPTION_TYPES_FETCH_ERROR = `${namespace}/EXEMPTION_TYPES_FETCH_ERROR`;

export const CREATE_EXEMPTION_START = `${namespace}/CREATE_EXEMPTION_START`;
export const CREATE_EXEMPTION_SUCCESS = `${namespace}/CREATE_EXEMPTION_SUCCESS`;
export const CREATE_EXEMPTION_ERROR = `${namespace}/CREATE_EXEMPTION_ERROR`;

export const UPDATE_EXEMPTION_START = `${namespace}/UPDATE_EXEMPTION_START`;
export const UPDATE_EXEMPTION_SUCCESS = `${namespace}/UPDATE_EXEMPTION_SUCCESS`;
export const UPDATE_EXEMPTION_ERROR = `${namespace}/UPDATE_EXEMPTION_ERROR`;

export const DELETE_EXEMPTION_START = `${namespace}/DELETE_EXEMPTION_START`;
export const DELETE_EXEMPTION_SUCCESS = `${namespace}/DELETE_EXEMPTION_SUCCESS`;
export const DELETE_EXEMPTION_ERROR = `${namespace}/DELETE_EXEMPTION_ERROR`;

export const TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_START = `${namespace}/TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_START`;
export const TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_SUCCESS = `${namespace}/TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_SUCCESS`;
export const TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_ERROR = `${namespace}/TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_ERROR`;

export const fetchAllTaxingUnitGroups = makeApiActionCreatorV3(
  api.fetchAllTaxingUnitGroups,
  TAXING_UNIT_GROUPS_FETCH_ALL_START,
  TAXING_UNIT_GROUPS_FETCH_ALL_SUCCESS,
  TAXING_UNIT_GROUPS_FETCH_ALL_ERROR,
);

export const fetchTaxingUnitGroup = makeApiActionCreatorV3(
  api.fetchTaxingUnitGroup,
  TAXING_UNIT_GROUPS_FETCH_START,
  TAXING_UNIT_GROUPS_FETCH_SUCCESS,
  TAXING_UNIT_GROUPS_FETCH_ERROR,
);

export const insertTaxingUnitGroup = makeApiActionCreatorV3(
  api.insertTaxingUnitGroup,
  TAXING_UNIT_GROUPS_INSERT_START,
  TAXING_UNIT_GROUPS_INSERT_SUCCESS,
  TAXING_UNIT_GROUPS_INSERT_ERROR,
);

export const updateTaxingUnitGroup = makeApiActionCreatorV3(
  api.updateTaxingUnitGroup,
  TAXING_UNIT_GROUPS_UPDATE_START,
  TAXING_UNIT_GROUPS_UPDATE_SUCCESS,
  TAXING_UNIT_GROUPS_UPDATE_ERROR,
);

export const deleteTaxingUnitGroup = makeApiActionCreatorV3(
  api.deleteTaxingUnitGroup,
  TAXING_UNIT_GROUPS_DELETE_START,
  TAXING_UNIT_GROUPS_DELETE_SUCCESS,
  TAXING_UNIT_GROUPS_DELETE_ERROR,
);

export const fetchTaxingUnitList = makeApiActionCreatorV3(
  api.fetchTaxingUnitList,
  TAXING_UNIT_LIST_FETCH_START,
  TAXING_UNIT_LIST_FETCH_SUCCESS,
  TAXING_UNIT_LIST_FETCH_ERROR,
);

export const fetchGroupTaxingUnitList = makeApiActionCreatorV3(
  api.fetchGroupTaxingUnitList,
  TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_START,
  TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_SUCCESS,
  TAXING_UNIT_GROUP_FETCH_TAXING_UNITS_ERROR,
);

export const deleteTaxingUnit = makeApiActionCreatorV3(
  api.deleteTaxingUnit,
  TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_START,
  TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_SUCCESS,
  TAXING_UNIT_GROUP_DELETE_TAXING_UNIT_ERROR,
);

export const updateTaxingUnitRequired = makeApiActionCreatorV3(
  api.updateTaxingUnitRequired,
  TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_START,
  TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_SUCCESS,
  TAXING_UNIT_GROUP_UPDATE_TAXING_UNIT_REQUIRED_ERROR,
);

export const insertTaxingUnit = makeApiActionCreatorV3(
  api.insertTaxingUnit,
  TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_START,
  TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_SUCCESS,
  TAXING_UNIT_GROUP_INSERT_TAXING_UNIT_ERROR,
);

export const fetchExemptionMappings = makeApiActionCreatorV3(
  api.fetchExemptionMappings,
  EXEMPTION_MAPPINGS_FETCH_START,
  EXEMPTION_MAPPINGS_FETCH_SUCCESS,
  EXEMPTION_MAPPINGS_FETCH_ERROR,
);

export const fetchExemptionTypes = makeApiActionCreatorV3(
  api.fetchExemptionTypes,
  EXEMPTION_TYPES_FETCH_START,
  EXEMPTION_TYPES_FETCH_SUCCESS,
  EXEMPTION_TYPES_FETCH_ERROR,
);

export const fetchExemptionApplyTo = makeApiActionCreatorV3(
  api.fetchExemptionApplyTo,
  EXEMPTION_APPLYTO_FETCH_START,
  EXEMPTION_APPLYTO_FETCH_SUCCESS,
  EXEMPTION_APPLYTO_FETCH_ERROR,
);

export const createExemption = makeApiActionCreatorV3(
  api.createExemption,
  CREATE_EXEMPTION_START,
  CREATE_EXEMPTION_SUCCESS,
  CREATE_EXEMPTION_ERROR,
);

export const updateExemption = makeApiActionCreatorV3(
  api.updateExemption,
  UPDATE_EXEMPTION_START,
  UPDATE_EXEMPTION_SUCCESS,
  UPDATE_EXEMPTION_ERROR,
);

export const deleteExemption = makeApiActionCreatorV3(
  api.deleteExemption,
  DELETE_EXEMPTION_START,
  DELETE_EXEMPTION_SUCCESS,
  DELETE_EXEMPTION_ERROR,
);
